/* Default Color Palette for the app */
export const COLOR_PALETTE = {
  white: '#FFFFFF',
  black: '#000000',
  grey: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D9D9D9',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
  },
  orange: {
    50: '#ffcab0',
    100: '#fcb390',
    200: '#fa9b6e',
    300: '#ff8347',
    400: '#fc7b3d',
    500: '#f37335',
    600: '#f7641e',
    700: '#f75c11',
    800: '#f55407',
    900: '#ff5403',
  },
  blue: {
    50: '#b3d6fc',
    100: '#8fc1f7',
    200: '#6bb1ff',
    300: '#438ad9',
    400: '#326ba8',
    500: '#0056b3',
    600: '#024d9e',
    700: '#013d7d',
    800: '#012d5c',
    900: '#011f40',
  },
  scrollbarTrack: '#F1F1F1',
  scrollbarThumb: '#888888',
  scrollbarHover: '#555555',
};
